import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TrailerFormLayout } from "./components/form";

const TrailerEditPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  return (
    <TrailerFormLayout
      mode="edit"
      entityId={id}
      title="Edit Trailer"
      onSuccess={() => navigate("/trailers")}
    />
  );
};

export default TrailerEditPage;





